import { render, staticRenderFns } from "./we.vue?vue&type=template&id=b4ccd5f6&scoped=true&"
import script from "./we.vue?vue&type=script&lang=js&"
export * from "./we.vue?vue&type=script&lang=js&"
import style0 from "./we.vue?vue&type=style&index=0&id=b4ccd5f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ccd5f6",
  null
  
)

export default component.exports